<script setup>
// layout -> bắt buộc
import Layout from "@/layouts/main.vue";
import mushroom from "cem-primary-api";
import { onMounted, reactive, ref, watch } from "vue";
import MethodService from "@/service/MethodService";
import DataForm from "./dataFormSubDepartment";
import { langWeb } from "@/stores/lang";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import LanguageService from "../../service/LanguageService";
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const rolesUser = ref([]);
const lang_web = langWeb();
const lang = ref(lang_web.showLang.toLocaleUpperCase());
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const loading = ref(false);
const dataTables = reactive({ value: [] });
const getListPhongBan = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
    showFormSearch: tableRules.showFormSearch,
  };
  let query = {
    filters: tableRules.filters,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
    showFormSearch: tableRules.showFormSearch,
  };
  router.replace({
    name: "ListPhongBan",
    query: query,
  });

  try {
    const response = await mushroom.sub_department.listAsync(dataFilter);

    if (response.result) {
      dataTables.value = [...response.result];
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  let query = Object.assign({}, route.query);
  query.showFormSearch = tableRules.showFormSearch;
  router.push({
    name: "ListPhongBan",
    query: query,
  });
};

const fn_handle = (type, scope, row) => {
  if (type == "update") {
    router.push({
      name: "UpdatePhongBan",
      params: { id: row.id },
    });
  } else {
    Swal.fire({
      title: LanguageService?.[lang.value]?.t_warning,
      text: LanguageService?.[lang.value]?.toastr_delete_sub_department,
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: LanguageService?.[lang.value]?.swal_accept,
      cancelButtonText: LanguageService?.[lang.value]?.swal_cancel,
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.sub_department.deleteAsync({
            id: row.id, // required
          });
          if (response.result) {
            toastr.success(t("toastr_delete_success"));
            getListPhongBan();
          }
        } catch (e) {
          if (e.detail === "Tồn tại người dùng thuộc phòng ban này")
            toastr.error(t("toastr_exists_user_belong_to_sub_dept"));
          else toastr.error(t("toast_delete_sub_departmet_fail"));
        }
      }
    });
  }
};

const addPhongBan = () => {
  router.push({
    name: "ThemMoiPhongBan",
  });
};

const fn_TimKiem = () => {
  if (
    tableRules.dataSearch.value.name ||
    tableRules.dataSearch.value.name.trim() == ""
  ) {
    tableRules.dataSearch.value.name = tableRules.dataSearch.value.name.trim();
    tableRules.filters = MethodService.filterTable(
      JSON.stringify(tableRules.dataSearch)
    );
  }
  tableRules.offset = 0;
  tableRules.sort = "";
  getListPhongBan();
};

const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  getListPhongBan();
};

const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};

const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};

const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};

const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * tableRules.limit;
  getListPhongBan();
};
const fn_tableSortChange = async (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  await getListPhongBan();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
};

watch(
  () => lang_web.showLang,
  (newLang) => {
    lang.value = newLang.toLocaleUpperCase();
  }
);
onMounted(async () => {
  const response = JSON.parse(localStorage.getItem("userInfo"));
  rolesUser.value = response.result.roles;
  fn_hashUrl();
  await getListPhongBan();
});
</script>

<template>
  <Layout>
    <div class="card">
      <div class="card-header justify-content-between" style="display: flex">
        <h3 class="text-uppercase mb-0">{{ $t("t_list_sub_department") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border mr-2"
              @click="fn_showFormTimKiem"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="addPhongBan"
              v-if="
                rolesUser.includes('Admin') ||
                rolesUser.includes('AdminPrimary')
              "
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-if="tableRules.showFormSearch"
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  lable-position="top"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="rulesForm"
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="12">
                      <el-form-item :label="$t('t_sub_department_name')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="$t('t_place_sub_department_name')"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <div class="text-center">
                    <a
                      class="btn btn-soft-secondary btn-border mx-3"
                      style="width: 80px"
                      @click="fn_showFormTimKiem"
                    >
                      {{ $t("t-hide") }}
                    </a>
                    <button
                      class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                      style="width: 100px"
                      native-type="submit"
                      @click="fn_TimKiem"
                    >
                      {{ $t("t-search") }}
                    </button>
                  </div>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="tableRules.limit"
              :page-sizes="tableRules.lengthMenu"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @currentChange="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              background
              layout="total,sizes,prev,pager,next,jumper"
            />
          </div>
          <el-table
            size="small"
            style="width: 100%"
            max-height="500"
            v-loading="loading"
            :empty-text="$t('t-no-data')"
            :data="dataTables.value"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              props: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop="index"
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t_sub_department_name')"
              min-width="250"
              align="center"
              sortable="custom"
            >
              <template #default="scope">
                <el-tooltip
                  class="box-item"
                  effect="light"
                  placement="top"
                  :content="scope.row.name"
                >
                  <div class="guideTitle">
                    {{ scope.row.name }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('t-action')" align="center" width="150">
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('t-edit')"
                    placement="top"
                  >
                    <button
                      v-if="
                        rolesUser.includes('Admin') ||
                        rolesUser.includes('AdminPrimary')
                      "
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.$index, scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('t-delete')"
                    placement="top"
                  >
                    <button
                      v-if="
                        rolesUser.includes('Admin') ||
                        rolesUser.includes('AdminPrimary')
                      "
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.$index, scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="tableRules.limit"
              :page-sizes="tableRules.lengthMenu"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @currentChange="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              background
              layout="total,sizes,prev,pager,next,jumper"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<link type="scss" src="./phongban.scss" />
